import { Formik, Form, Field, ErrorMessage } from "formik";
import { useHistory } from "react-router-dom";
import ClevertapReact from 'clevertap-react';
import React, {useState} from 'react';

export default function EmployeeDetails({ setFormData, stepperStateValue }) {

    const history = useHistory();
    const [serviceName, setServiceName] = useState('Infant Care');

    function validateForm(values) {
        const errors = {};
        if (!values.name || values.name.trim().length == 0) {
            errors.name = "Required";
        }
        if (!values.email || values.email.trim().length == 0) {
            errors.email = "Required";
        }
        if (!values.mobileNumber) {
            errors.mobileNumber = "Required";
        }
        // if (!values.pincode) {
        //     errors.pincode = "Required";
        // }
        if (
            values.mobileNumber &&
            values.mobileNumber.toString().length !== 10
        ) {
            errors.mobileNumber = "Mobile Number should be 10 digits";
        }
        if (values.mobileNumber <= 0) {
            errors.mobileNumber = "Please enter valid Mobile Number";
        }
        // if (
        //     values.pincode &&
        //     values.pincode.toString().length !== 6
        // ) {
        //     errors.pincode = "Pincode should be 6 digits";
        // }
        console.log(222,errors);
        return errors;
    }

    function submitForm(values){
        console.log(111,values);
        stepperStateValue(2);
        setFormData({
            CompanyName: "values.companyName",
            Email: "kiran.kumar@medibuddy.in",
            MobileNumber: "9686967013",
            CompanyName: "MediBuddy",
            CompanyUrl: "https://www.medibuddy.in/",
            Name: "Kiran Kumar",
            Address: "values.address",
            Pincode: "560034",
            EmpCount: 10
        })
        ClevertapReact.event("Clicked next on Sign up, Step 1 Sign up Page")
    }

    return (
        <div className="bg-white px-5 lg:px-16 shadow-lg lg:ml-10 rounded-3xl mt-10 pb-6">
            <p className="font-black text-2xl pt-10 lg:ml-10">Register for Pre / Post Natal Care</p>
            <Formik
                initialValues={{
                    name: "",
                    email: "",
                    companyName: "",
                    mobileNumber: "",
                    address: "",
                    pincode: "",
                    websiteUrl: "",
                    empCount: ""
                }}
                validate={(values) => {
                    console.log(1111,values);
                    return validateForm(values);
                }}
                onSubmit={(values, { setSubmitting }) => {
                    console.log('valuess--',values);
                    submitForm(values);
                }}
            >
                <Form action="">
                    <div className="lg:mx-10 mt-5 mb-10">
                        <div className="flex flex-col space-y-5">
                            <div className="flex flex-wrap justify-between">
                                <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="name">
                                        Name Of The Employee{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="name"
                                        name="name"
                                        type="text"
                                    />
                                    <ErrorMessage
                                        className="text-red-600"
                                        name="name"
                                        component="div"
                                    />
                                </div>
                                <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="email">
                                        Official EmailId{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="email"
                                        name="email"
                                        type="email"
                                    />
                                    <ErrorMessage
                                        className="text-red-600"
                                        name="email"
                                        component="div"
                                    />
                                </div>
                            </div>
                            <div className="flex flex-wrap lg:space-x-8 justify-between">
                                <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="EmployeeId">
                                        EmployeeId{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="EmployeeId"
                                        name="EmployeeId"
                                        type="text"
                                    />
                                    <ErrorMessage
                                        className="text-red-600"
                                        name="EmployeeId"
                                        component="div"
                                    />
                                </div>
                                <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="mobileNumber">
                                        Mobile Number{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="mobileNumber"
                                        name="mobileNumber"
                                        type="number"
                                    />
                                    <ErrorMessage
                                        className="text-red-600"
                                        name="mobileNumber"
                                        component="div"
                                    />
                                </div>
                            </div>
                            {/* <div className="flex flex-wrap lg:space-x-8 justify-between">
                                <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="serviceName">
                                        Select the service{" "}
                                        <span className="text-red-600">*</span>
                                    </label>

                                    <select
                                        name="serviceName"
                                        //value={values.color}
                                        onChange={(e)=>setServiceName(e.target.value)}
                                        //onBlur={handleBlur}
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        style={{ display: "block" }}
                                    > */}
                                        {/* <option value="" label="Select a service">
                                        Select a service
                                        </option> */}
                                        {/* <option value="Infant Care" label="Infant Care">
                                        Infant Care
                                        </option>
                                        <option value="Pre Post Natal Care" label="Pre Post Natal Care">
                                        Pre Post Natal Care
                                        </option>
                                    </select>     */}
                                    {/* <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="address"
                                        name="address"
                                        type="option"
                                    /> */}
                                 {/* </div> */}
                                {/* </div> */}
                                {/* <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                    <label for="pincode">
                                        Pincode{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <Field
                                        className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                        id="pincode"
                                        name="pincode"
                                        type="number"
                                    />
                                    <ErrorMessage
                                        className="text-red-600"
                                        name="pincode"
                                        component="div"
                                    />
                                </div> */}
                            {/* </div> */}
                            {/* { */}
                                {/* serviceName==="Infant Care"? */}
                                {/* <><div className="flex flex-wrap justify-between">
                                        <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                            <label for="name">
                                                Name Of The Baby{" "}
                                                <span className="text-red-600">*</span>
                                            </label>
                                            <Field
                                                className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                id="babyname"
                                                name="babyname"
                                                type="text" />
                                            <ErrorMessage
                                                className="text-red-600"
                                                name="babyname"
                                                component="div" />
                                        </div>
                                        <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                            <label for="babygender">
                                                Gender Of The Baby{" "}
                                                <span className="text-red-600">*</span>
                                            </label>
                                            <select
                                                name="babygender"
                                                //value={values.color}
                                               // onChange={(e) => setServiceName(e.target.value)}
                                                //onBlur={handleBlur}
                                                className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                style={{ display: "block" }}
                                            > */}
                                                {/* <option value="" label="Select a service">
Select a service
</option> */}
                                                {/* <option value="Girl" label="Girl">
                                                    Girl
                                                </option>
                                                <option value="Boy" label="Boy">
                                                    Boy
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                        <div className="flex flex-wrap lg:space-x-8 justify-between">
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="city">
                                                    City{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="city"
                                                    name="city"
                                                    type="text" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="city"
                                                    component="div" />
                                            </div> */}
                                            {/* <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="state">
                                                    State{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="state"
                                                    name="state"
                                                    type="text" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="state"
                                                    component="div" />
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap lg:space-x-8 justify-between">
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="dob">
                                                    Date Of Birth Of The Baby{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="dob"
                                                    name="dob"
                                                    type="date" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="dob"
                                                    component="div" />
                                            </div>
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="apptDate">
                                                    Appointment Date{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="apptDate"
                                                    name="apptDate"
                                                    type="date" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="apptDate"
                                                    component="div" />
                                            </div>
                                        </div><div className="flex flex-wrap lg:space-x-8 justify-between">
                                            <label for="services">
                                                    Select Service(s) Required{" "}
                                                    <span className="text-red-600">*</span>
                                            </label>
                                            <div className="flex flex-col lg:space-y-2 justify-between relative left-8" role="group" aria-labelledby="checkbox-group">
                                                <label>
                                                    <Field type="checkbox" name="checked" value="doctorconsultation" />
                                                    <span className="m-2">Doctor Consultation</span>
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="hearing" value="hearing" />
                                                    <span className="m-2">Evoked potential test (hearing)</span>
                                                    
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="vision" value="vision" />
                                                    <span className="m-2">Strabismus test (vision)</span>
                                                    
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="scid" value="scid" />
                                                    <span className="m-2">Severe Combined Immunodeficiency (SCID) screening</span>
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="vaccination" value="vaccination" />
                                                    <span className="m-2">Vaccinations</span>
                                                </label>
                                            </div>
                                        </div></>
                            : */}
                            <><div className="flex flex-wrap justify-between">
                                        <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                            <label for="serviceFor">
                                                Service Is For{" "}
                                                <span className="text-red-600">*</span>
                                            </label>
                                            <select
                                                name="serviceFor"
                                                //value={values.color}
                                                //onChange={(e) => setServiceName(e.target.value)}
                                                //onBlur={handleBlur}
                                                className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                style={{ display: "block" }}
                                            >
                                                {/* <option value="" label="Select a service">
Select a service
</option> */}
                                                <option value="Self" label="Self">
                                                    Self
                                                </option>
                                                <option value="Spouse" label="Spouse">
                                                    Spouse
                                                </option>
                                            </select>
                                        </div>
                                        <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                            <label for="name">
                                                Name Of The Patient{" "}
                                                <span className="text-red-600">*</span>
                                            </label>
                                            <Field
                                                className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                id="uname"
                                                name="uname"
                                                type="text" />
                                            <ErrorMessage
                                                className="text-red-600"
                                                name="uname"
                                                component="div" />
                                        </div>
                                    </div>
                                        <div className="flex flex-wrap lg:space-x-8 justify-between">
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="city">
                                                    City{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="city"
                                                    name="city"
                                                    type="text" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="city"
                                                    component="div" />
                                            </div>
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="state">
                                                    State{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="state"
                                                    name="state"
                                                    type="text" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="state"
                                                    component="div" />
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap lg:space-x-8 justify-between">
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="mensdate">
                                                LMP Date (last menstrual period){" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="mensdate"
                                                    name="mensdate"
                                                    type="date" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="mensdate"
                                                    component="div" />
                                            </div>
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-1">
                                                <label for="apptDate">
                                                    Appointment Date{" "}
                                                    <span className="text-red-600">*</span>
                                                </label>
                                                <Field
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="apptDate"
                                                    name="apptDate"
                                                    type="date" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="apptDate"
                                                    component="div" />
                                            </div>
                                        </div><div className="flex flex-wrap lg:space-x-8 pt-8 justify-between">
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-6">
                                                <label for="verifydocuments">
                                                Upload Pregnancy Confirmation Report{" "}
                                                <span className="text-red-600">*</span>
                                                </label>
                                                <input
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="verifydocuments"
                                                    name="verifydocuments"
                                                    type="file" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="verifydocuments"
                                                    component="div" />
                                            </div>
                                            <div className="w-full lg:w-5/12 flex flex-col space-y-6">
                                                <label for="verifydocuments">
                                                Upload Ultrasound Report {" "}
                                                <span className="text-red-600">*</span>
                                                </label>
                                                <input
                                                    className="border-2 border-grey-400 h-12 px-4 rounded-xl mt-2"
                                                    id="verifydocuments2"
                                                    name="verifydocuments2"
                                                    type="file" />
                                                <ErrorMessage
                                                    className="text-red-600"
                                                    name="verifydocuments2"
                                                    component="div" />
                                            </div>
                                        </div>
                                        {/* <div className="flex flex-wrap lg:space-x-8 pt-6 justify-between">
                                            <label for="services">
                                                    Select Service(s) Required{" "}
                                                    <span className="text-red-600">*</span>
                                            </label>
                                            <div className="flex flex-col lg:space-y-2 justify-between relative lg:ml-0" role="group" aria-labelledby="checkbox-group">
                                                <label>
                                                    <Field type="checkbox" name="checked" value="doctorconsultation" />
                                                    <span className="m-2">Doctor Consultation</span>
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="labtest" value="labtest" />
                                                    <span className="m-2">Lab Test</span>
                                                    
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="scan" value="scan" />
                                                    <span className="m-2">Scan</span>
                                                    
                                                </label>
                                                <label>
                                                    <Field type="checkbox" name="other" value="other" />
                                                    <span className="m-2">Other</span>
                                                </label>
                                            </div>
                                        </div> */}
                                        </>
                            {/* } */}
                        </div>
                        <div className="flex justify-end space-x-4">
                            <Field
                                className="btn-secondary shadow-lg mt-10 px-10"
                                type="button"
                                value="Back"
                                onClick={() =>{
                                    ClevertapReact.event("Back to Home from Signup Page, Step 1")
                                    history.push('/')
                                } }
                            />
                            <Field
                                className="btn-primary shadow-lg mt-10 px-10"
                                type="submit"
                                value="Submit"
                            />
                        </div>
                    </div>
                </Form>
            </Formik>
        </div>
    );
}
